const trackingUtils = require('od-modules/utils/tracking.utils');
const UiGoogleMap = require('od-modules/helpers/map/ui/hotel_result_list');
const commonParser = require('od-modules/parsers/dynpack_common');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
const ADDONS_OPTIONS = {
    clusterCustomConfig: {
        minimumClusterSize: 5,
    },
    infoWindowOptions: {
        disableAutoPan: true,
    },
};

function updateAfterIdleEventMap() {
    return Odigeo._.after(!$.fx.muted && 2, Odigeo._.bind(this.update, this));
}

function hasToCloseHotelInfoOnUserAction(userTarget) {
    return this.mapMngr.isInfoWindowOpen() &&
        !this.mapMngr.hasSelectedMarkerCluster(userTarget) &&
        !this.mapMngr.hasDragInteraction &&
        !this.mapMngr.hasHotelInfoElement(userTarget);
}

module.exports = Odigeo.View.extend({
    selectors: {
        mapDetailsContainer: '.accommodation_details_super_container',
        mapContainer: '.accommodation_map_container',
    },

    events: {
        'tap .result_card': 'onSelectAccommodation',
        'tap .result_card_full_price': 'onSelectAccommodation',
        'tap .accommodation_close_infowindow': 'closeInfoWindow',
    },
    showPrices: true,
    absConfig: null,
    mapMngr: null,
    mapEvents: null,
    currCenter: false,
    isUpdatedOnSearchResults: false,

    init: function() {
        this.listenToOnce(this.model, 'update_map', Odigeo._.bind(this.firstUpdate, this));
        this.listenTo(this.model, 'update_map', updateAfterIdleEventMap.call(this));
        this.trackEvent = Odigeo._.bind(trackingUtils.trackEvent, trackingUtils, 'results_list_hotels');
        this.listenTo(this.model, 'loadAccommodationResults', this.update);
    },
    async firstUpdate() {
        this.absConfig = {
            hasTooltipTemplate: false,
            hasBubbleTemplate: true,
            hasTopVisibilityMarkerPreselected: false,
            hasToggleMarkerButtons: false,
            clickableIcons: false,
        };
        this.mapMngr = new UiGoogleMap(Odigeo._.extend({
            templates: this.staticTemplates.hotel,
            absConfig: this.absConfig,
            fullscreenControl: false,
        }, this.widget.options, ADDONS_OPTIONS));
        await this.mapMngr.isReady;
        this.mapMngr.startMap({
            mapDiv: this.$cachedSelectors.mapContainer.get(0),
            btnGroupCbk: Odigeo._.bind(this.changeMarkers, this),
        });
        this.mapEvents = this.mapMngr.events.getListeners();
        this.bindMapEvents();
    },

    update: function() {
        this.model.publishMarkers(this.refreshMap());
    },

    setContainerHeight: function(height) {
        this.$cachedSelectors.mapContainer.height(height);
    },

    changeMarkers: function(eventData) {
        if (!Odigeo._.isEqual(eventData.showPrices, this.showPrices)) {
            this.showPrices = eventData.showPrices;
            this.refreshMap();
        }
    },

    toggle: function() {
        return this.open();
    },

    async open() {
        if (!Odigeo._.isNull(this.mapMngr)) {
            this.mapMngr.setHasUserInteraction(false);
            this.$cachedSelectors.mapDetailsContainer.addClass('map-opened');
            await this.mapMngr.isReady;
            this.mapMngr.resizeMap();
            this.trackEvent('map_open_all_hotels');
        }
    },

    closeInfoWindow: function() {
        this.mapMngr.closeInfoWindow();
    },

    refreshMap: function() {
        return this.mapMngr.refresh({
            dataMarkers: this.model.toJSON(),
            widgetOptions: this.widget.options,
            absConfig: this.absConfig,
            isCustomMarker: this.showPrices,
        });
    },

    bindMapEvents: function() {
        const infoWindow = this.mapMngr.getInfoWindow();

        this.mapEvents.listenToOnce(this.mapMngr.map, {
            'idle': Odigeo._.bind(this.update, this),
        });
        this.mapEvents.listenTo(this.mapMngr.map, {
            'idle': Odigeo._.bind(function() {
                if (!this.mapMngr.hasUserInteraction) {
                    this.mapMngr.resizeMap();
                }
                this.mapMngr.setHasUserInteraction(true);
            }, this),
            'resize': this.mapMngr.refreshBounds.bind(this.mapMngr),
            'zoom_changed': this.mapMngr.closeHotelInfo.bind(this.mapMngr),
            'center_changed': Odigeo._.debounce(Odigeo._.bind(function() {
                this.currCenter = this.mapMngr.map.getCenter();
            }, this), 300),
        });
        this.mapEvents.listenToDom(this.mapMngr.map.getDiv(), {
            'click.closeInfoWindow': Odigeo._.bind(this.preventCloseInfoWindow, this, infoWindow),
            'click.activeMap': Odigeo._.partial(this.mapMngr.setHasUserInteraction, true),
        });
        this.mapEvents.listenToDom(window, {
            'resize': Odigeo._.debounce(Odigeo._.bind(this.onResize, this), 200),
        });
        this.mapEvents.listenTo(infoWindow, {
            'openWindowByClickOnMarker': Odigeo._.bind(this.trackEventMapOnClickMarker, this),
            'clickCluster': Odigeo._.bind(this.trackEventMapOnClickCluster, this),
            'domready': !$.fx.muted ? Odigeo._.bind(this.setCardStyle, this) : Odigeo._.noop,
        });
    },

    preventCloseInfoWindow: function(infoWindow, evt) {
        if (hasToCloseHotelInfoOnUserAction.call(this, evt.target)) {
            this.mapMngr.closeHotelInfo();
        }
    },

    onResize: function() {
        const infoWindow = this.mapMngr.getInfoWindow();

        if (this.mapMngr.isInfoWindowOpen()) {
            this.mapMngr.openInfoWindowByMarker(infoWindow.getAnchor());
        } else if (this.currCenter) {
            this.mapMngr.map.setCenter(this.currCenter);
        }
    },

    onSelectAccommodation: Odigeo._.debounce(function(evt) {
        const $target = $(evt.currentTarget);
        const key = $target.data('key');
        const isFullFareClicked = $target.is('.result_card_full_price');

        const accommodation = this.mapMngr.getMarkerByKey(key.toString()).dataMarker;
        const label = commonParser.buildHotelSelectedLabel(accommodation, 'NA', 'map');
        const metric = Odigeo.SessionScope.flow === 'mobile' ? 'LOAD_ROOM_SELECTION_MOBILE' : 'LOAD_ROOM_SELECTION_DESKTOP';
        const providerId = accommodation.accommodationDeal.providerId;

        trackingUtils.trackEventWithCategory('dynpack_hotel_results', 'results_list_hotels', `hotel_select_map_provider:${providerId}`);
        trackingUtils.startMetric(metric);
        Odigeo.trigger(this.widget.id + ':selectAccommodation', {
            key: key,
            isPriceWithoutDiscountSelected: isFullFareClicked,
        }, label, 'results_list_hotels_map');
        trackClickEvent(evt);
        evt.stopPropagation();
    }, 500, {leading: true}),

    setCardStyle: function() {
        const $gmInfoWindow = $('.gm-style-iw');
        this.$cachedSelectors.mapContainer.addClass('odf-new-card-style');
        this.removeInfoboxElements($gmInfoWindow);
    },

    removeInfoboxElements: function($gmInfoWindow) {
        const iwBackground = $gmInfoWindow.prev();
        const $closeButton = $('.gm-ui-hover-effect');

        const $gmArrowContainer = $('.gm-style .gm-style-iw-t');
        const $hotelCard = $('.gm-style .od-hotel-card');

        $hotelCard.removeClass('odf-box');
        $gmArrowContainer.addClass('d-none');
        $closeButton.html('<span class="odf-clickable odf-icon odf-icon-cross-light gm-close-card-button"></span>');
        iwBackground.children(':nth-child(2), :nth-child(4)').css({'display': 'none'});
    },

    trackEventMapOnClickMarker: function(dataMarker) {
        const label = commonParser.buildHotelSelectOrClickLabel(dataMarker, 'hotel_click', 'map');
        trackingUtils.trackEvent('results_list_hotels_map', label);
    },

    trackEventMapOnClickCluster: function() {
        trackingUtils.trackEvent('results_list_hotels', 'map_click_bubble');
    },
});
